import FlexContainer from '@busybusy/webapp-react-ui/dist/components/FlexContainer/FlexContainer';
import classNames from 'classnames';
import { Badge } from 'components';
import Typography from 'components/foundation/text/Typography/Typography';
import { ISchedulingTimeOffEvent } from 'containers/scheduling/types/types';
import { getSchedulingTimeOffDuration } from 'containers/scheduling/utils/utils';
import { t } from 'i18next';
import { getFullNameFromMember } from 'utils/stringUtils';
import { getTimeOffTypeTitle } from 'utils/timeOffUtils';
import SchedulingEventContainer from '../SchedulingEventContainer/SchedulingEventContainer';

export interface ISchedulingTimeOffEventProps {
  event: ISchedulingTimeOffEvent;
  className?: string | object;
}

const SchedulingTimeOffEvent = ({ event, className }: ISchedulingTimeOffEventProps) => {
  return (
    <SchedulingEventContainer className={classNames('scheduling-time-off-event', className)}>
      <FlexContainer justifyContent="space-between">
        <Typography tag="div">{getSchedulingTimeOffDuration(event)}</Typography>
        <Badge color="dark-blue">
          <Typography tag="span" textAlign="center">
            {t('Time Off')}
          </Typography>
        </Badge>
      </FlexContainer>
      <Typography className="ellipsis" tag="div">
        {event.paid
          ? `${t('Paid Time Off')} (${getTimeOffTypeTitle(event.type)})`
          : `${t('Unpaid Time Off')}  (${getTimeOffTypeTitle(event.type)})`}
      </Typography>
      <Typography className="ellipsis" tag="div">
        {event.members.map(getFullNameFromMember).join(', ')}
      </Typography>
    </SchedulingEventContainer>
  );
};

export default SchedulingTimeOffEvent;
